import { render, staticRenderFns } from "./engagementPermissionTab.vue?vue&type=template&id=3b6fe82b&scoped=true&"
import script from "./engagementPermissionTab.vue?vue&type=script&lang=js&"
export * from "./engagementPermissionTab.vue?vue&type=script&lang=js&"
import style0 from "./engagementPermissionTab.vue?vue&type=style&index=0&id=3b6fe82b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6fe82b",
  null
  
)

export default component.exports